<template>
  <div>
    <span class="title">是否已确认:</span>
    <el-select v-model="value" placeholder="请选择是否已确认" clearable>
      <el-option label="未登录" :value="0"></el-option>
      <el-option label="已使用" :value="1"></el-option>
      <el-option label="全部" :value="-1"></el-option>
    </el-select>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "CheckSelect",
  
  mixins: [BaseVue],
  
  data() {
    return {
      value: null
    };
  },
  
  methods: {
    init() {
      this.value = "";
    }
  },
  
  watch: {
    value: {
      handler(newVal) {
        // console.log("on value changed", newVal);
        this.$emit("onValueChanged", newVal);
      }
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>